<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="4">
        <site-filter
          siteListGetter="aiFactory/getSiteConnectors"
          itemValue="site.id"
          itemText="site.name"
          store="aiFactory"
          storeGetter="getSelectedSites"
          :multiple="false"
          :dependsOnSiteGroups="false"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="searchStr" label="Mots-clés" dense />
      </v-col>
      <v-col cols="2" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="disableSearch" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import SiteFilter from "@/components/common/filters/SiteFilter";

import { URL_PARAM_NAMES } from "@/utils/constants";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    SiteFilter,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { isLoading } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
    });

    // =>  METHODS

    // =>  COMPUTED
    const searchStr = computed({
      get: () => store.getters["aiFactory/getKeywords"],
      set: (value) => {
        store.dispatch("aiFactory/updateKeywords", value);

        if (page.isInitialized) {
          // Only update user changes, not initialization
          addQueryStringParam({
            param: URL_PARAM_NAMES["Search"],
            value: value,
            // is_multiple: false,
            // is_integer: false,
            // is_boolean: false,
          });
        }
      },
    });
    const site = computed(() => store.getters["aiFactory/getSelectedSites"]);

    const disableSearch = computed(
      () => !searchStr.value || !site.value || isLoading.value
    );

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: "aiFactory/updateKeywords",
        param: URL_PARAM_NAMES["Search"],
        value: searchStr.value,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
        // dependsOn: undefined,
      });

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      disableSearch,
      searchStr,
    };
  },
};
</script>

<style></style>
